// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface SystemListApiParameter extends ApiParameter {
    systemListName: string;
}

export interface SystemListModel {
    systemListName: string;
    description: string;
}

export interface SystemListCollectionModel extends BaseModel {
    values: SystemListModel[];
}

const systemListUrl = "api/custom/systemList/GetSystemListValues";

export async function getSystemList(parameter: SystemListApiParameter) {
    const systemListCollection = await get<SystemListCollectionModel>(systemListUrl, parameter);
    return systemListCollection;
}
